/**
 * @file  header/index.ts
 * @description  application header component
 *
 * @author ogarcia (ozkary)
 *
 */
import React, { Fragment, useState, useCallback } from 'react';
import { ContentLoader } from './content';
import { HeaderModel } from './header.model';
import ListLinks from '../../elements/ListLinks';
import Image from '../../elements/Image';
import * as S from './styles';
import './styles.scss';

/**
 * displays the app header with logo, and menu components
 */

const Header = (): JSX.Element => {
  const [Content, setContent] = useState<HeaderModel>({} as HeaderModel);

  const loadContent = useCallback(async () => {
    const content = (await ContentLoader).default;
    setContent(content);
  }, []);
  loadContent();
  return (
    <Fragment>
      <S.Div className="header__logo">
        <S.LogoContainer to="/" aria-label={Content.title}>
          <Image src={Content.image} title={Content.title} />
        </S.LogoContainer>
      </S.Div>
      <S.Div className="header__slogan">
        {Content.title} <S.SpanLabel className="">{Content.slogan}</S.SpanLabel>
      </S.Div>
      <S.Div className="header__social">
        <ListLinks items={Content.menu}></ListLinks>
      </S.Div>
    </Fragment>
  );
};

export default Header;
